import {AuthenticationService} from '../services/authentication.service';
import {CanActivate, Router} from '@angular/router';
import {Injectable} from '@angular/core';

@Injectable()
export class OnlyLoggedInUsersGuard implements CanActivate {
  constructor(protected authenticationService: AuthenticationService, private router: Router) {
  }

  canActivate() {
    if (this.authenticationService.isAuthenticated()) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
